<template>
    <LayoutWrapper :id="id">
        <LayoutPaddingSpace>
            <AlgorithmTypeSection />
        </LayoutPaddingSpace>
        <LayoutDivider />
        <LayoutPaddingSpace>
            <LayoutContainer v-if="!isNW">
                <LayoutColumn>
                    <SectionTitle>
                        {{ $t('Search.labels.searchParameters') }}
                    </SectionTitle>
                    <SectionBlock>
                        <AlignmentIdentityField />
                        <QueryIdentityField />
                        <QueryCoverageField />
                        <SubjectIdentityField />
                        <SubjectCoverageField />
                        <MaxTargetSequenceField />
                    </SectionBlock>
                </LayoutColumn>
                <LayoutColumn>
                    <SectionTitle>
                        {{ $t('Search.labels.algorithmSettings') }}
                    </SectionTitle>
                    <div>
                        <SectionBlock>
                            <MatchWithGapsField />
                            <EvalueField />
                            <LowComplexRegionField />
                        </SectionBlock>
                        <AlgorithmBlock v-if="!store.algorithmSettingsDisabled" />
                    </div>
                </LayoutColumn>
            </LayoutContainer>
            <LayoutContainer v-else>
                <LayoutColumn full>
                    <SectionTitle>
                        {{ $t('Search.labels.algorithmSettings') }}
                    </SectionTitle>
                    <SectionBlock>
                        <MatchWithGapsField />
                        <AlignmentIdentityField />
                        <NWGapOpenField />
                        <NWGapExtentField />
                        <NWScoreMatrixField />
                        <MaxTargetSequenceField />
                    </SectionBlock>
                </LayoutColumn>
            </LayoutContainer>
        </LayoutPaddingSpace>
        <ResetSection />
    </LayoutWrapper>
</template>

<script>
import BioSearchSettingProvider from '../BioSearchSettingProvider.vue';
import { MODIFICATION_SEARCH_ALGORITHM_TYPES } from '../constants';
import AlgorithmBlock from './Algorithm.prefab.vue';

export default {
    components: {
        AlgorithmBlock,
    },
    extends: BioSearchSettingProvider,
    computed: {
        isNW() {
            return this.store.algorithmType === MODIFICATION_SEARCH_ALGORITHM_TYPES.NW;
        },
    },
};
</script>
